import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUsers, 
  faHandsHelping, 
  faUserCog,
  faChartBar
} from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <div className="welcome-section">
        <h1>Bienvenido a Reassist</h1>
        <p className="subtitle">Sistema de Gestión de Asistencia Social</p>
      </div>
      
      <div className="quick-access-grid">
        <Link to="/beneficiaries" className="quick-access-card">
          <div className="icon-container">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <h2>Beneficiarios</h2>
          <p>Gestiona la información de los beneficiarios del programa</p>
        </Link>
        
        <Link to="/assistances" className="quick-access-card">
          <div className="icon-container">
            <FontAwesomeIcon icon={faHandsHelping} />
          </div>
          <h2>Asistencias</h2>
          <p>Registra y consulta las asistencias brindadas</p>
        </Link>
        
        <Link to="/users" className="quick-access-card">
          <div className="icon-container">
            <FontAwesomeIcon icon={faUserCog} />
          </div>
          <h2>Usuarios</h2>
          <p>Administra los usuarios del sistema</p>
        </Link>
        
        <Link to="/reports" className="quick-access-card">
          <div className="icon-container">
            <FontAwesomeIcon icon={faChartBar} />
          </div>
          <h2>Reportes</h2>
          <p>Visualiza estadísticas y genera informes</p>
        </Link>
      </div>
      
      <div className="recent-activity">
        <h2>Actividad Reciente</h2>
        <p>Próximamente: Panel de actividades recientes</p>
      </div>
    </div>
  );
};

export default Home; 